<template>
    <div>
        <toggle-filters v-model="openFilters"></toggle-filters>

        <chart-ordering
            :can-delete="canDeleteCharts"
            :can-update="canUpdateCharts"
            :open="openChartOrdering"
        ></chart-ordering>

        <div>
            <a  @click="onOpen" :class="{'': !isOpen, 'active': isOpen}" class="toggle-menu">
                <span></span><span></span><span></span>
            </a>

            <div :class="{'-right-100vw': !isOpen, 'right-0': isOpen}" class="fixed top-58 w-full max-w-270 h-full p-30 z-40 overflow-y-auto bg-blue-darkest mt-2 transition">
                
                <img :src="client.logo" :alt="client.name" class="max-w-116 mb-20">

                <p class="text-14">{{ client.name }}</p>
                <p class="text-12 text-blue-lightest mb-40">Signed in as {{ user.full_name }}</p>

                <ul class="text-14">
                    <li class="border-b border-blue-light h-40 leading-40">
                        <a href="/dashboard" class="flex items-center"><span class="w-32"><img src="/images/dashboard.svg" alt="Dashboard icon"></span><span>My dashboard</span></a>
                    </li>
                    <li v-if="hasCharts" class="border-b border-blue-light h-40 leading-40">
                        <a @click="onOpenChartOrdering" class="flex items-center cursor-pointer"><span class="w-32"><img src="/images/charts.svg" alt="Charts icon"></span><span>Manage my charts</span></a>
                    </li>
                    <li class="border-b border-blue-light h-40 leading-40">
                        <a href="/account" class="flex items-center"><span class="w-32"><img src="/images/user.svg" alt="User icon"></span><span>My settings</span></a>
                    </li>
                    <li v-if="canManageUsers" class="border-b border-blue-light h-40 leading-40">
                        <a href="/admin/users" class="flex items-center"><span class="w-32"><img src="/images/config.svg" alt="Config icon"></span><span>Admin</span></a>
                    </li>
                    <li v-if="clients.length > 0" class="border-b border-blue-light min-h-40 leading-40">
                        <a @click="showClientsMenu = !showClientsMenu" class="flex items-center cursor-pointer"><span class="w-32"><img src="/images/switch.svg" alt="Switch icon"></span><span>Switch dashboard</span></a>
                        <client-menu v-if="showClientsMenu" :clients="clients">
                            <ul slot-scope="{canUpdateClient, clients, currentClient, isLoggedIn, onSelectClient, showClients}" v-if="showClients">
                                <li v-for="client in clients" :key="client.id">
                                    <span class="flex justify-between items-center">
                                        <a @click="onSelectClient(client)" class="w-full cursor-pointer">{{ client.name }}</a>
                                        <a v-if="canUpdateClient(client.id)" :href="`/admin/clients/${client.id}/edit`" :title="`${client.name} Settings`" class="flex justify-center items-center h-40 w-40 cursor-pointer">
                                            <svg class="fill-blue-light" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                <path id="cog" d="M138.667,136a2.667,2.667,0,1,0-.781,1.885A2.569,2.569,0,0,0,138.667,136ZM144,134.865v2.313a.4.4,0,0,1-.083.24.317.317,0,0,1-.208.135l-1.927.292a6.674,6.674,0,0,1-.406.948q.365.521,1.115,1.438a.4.4,0,0,1,.1.26.348.348,0,0,1-.094.24,10.582,10.582,0,0,1-1.031,1.125q-.75.74-.979.74a.509.509,0,0,1-.271-.094l-1.437-1.125a5.945,5.945,0,0,1-.948.4,17.04,17.04,0,0,1-.3,1.938.351.351,0,0,1-.375.292h-2.312a.394.394,0,0,1-.255-.089.309.309,0,0,1-.12-.224l-.292-1.917a6.438,6.438,0,0,1-.937-.385l-1.469,1.115a.375.375,0,0,1-.26.094.359.359,0,0,1-.26-.115,13.748,13.748,0,0,1-1.719-1.75.407.407,0,0,1-.073-.24.4.4,0,0,1,.083-.24q.156-.219.531-.693t.563-.734a5.154,5.154,0,0,1-.427-1.031l-1.906-.281a.328.328,0,0,1-.219-.13.394.394,0,0,1-.083-.245v-2.312a.4.4,0,0,1,.083-.24.314.314,0,0,1,.2-.135l1.938-.292a5.146,5.146,0,0,1,.406-.958q-.417-.594-1.115-1.437a.391.391,0,0,1-.1-.25.439.439,0,0,1,.094-.24,10.345,10.345,0,0,1,1.026-1.12q.755-.745.984-.745a.444.444,0,0,1,.271.1l1.438,1.115a5.943,5.943,0,0,1,.948-.4,17.036,17.036,0,0,1,.3-1.937.351.351,0,0,1,.375-.292h2.313a.394.394,0,0,1,.255.089.309.309,0,0,1,.12.224l.292,1.917a6.438,6.438,0,0,1,.938.385l1.479-1.115a.338.338,0,0,1,.25-.094.4.4,0,0,1,.26.1,14.25,14.25,0,0,1,1.719,1.771.336.336,0,0,1,.073.229.4.4,0,0,1-.083.24q-.156.219-.531.693t-.562.734a6.275,6.275,0,0,1,.427,1.021l1.906.292a.328.328,0,0,1,.219.13A.394.394,0,0,1,144,134.865Z" transform="translate(-128 -128)"/>
                                            </svg>
                                        </a>
                                    </span>
                                </li>
                            </ul>
                        </client-menu>
                    <li v-if="canCreateClients" class="border-b border-blue-light h-40 leading-40">
                        <a href="/admin/clients/create" class="flex items-center"><span class="w-32"><img src="/images/add.svg" alt="Add icon"></span><span>Add new client</span></a>
                    </li>
                    <li class="border-b border-blue-light h-40 leading-40">
                        <logout class="flex items-center">
                            <span class="w-32"><img src="/images/exit.svg" alt="Exit icon"></span><span>Log out</span>
                        </logout>
                    </li>
                </ul>

            </div>
        </div>
    </div>
</template>

<script>
    import { get, sync } from "vuex-pathify"
    import ChartOrdering from "./chartOrdering"
    import ClickOutsideMixin from "../../mixins/clickOutside"
    import ClientMenu from "./clients/index"
    import ClientMenuMixin from "./clients/mixin"
    import Logout from "../logout"
    import ToggleFilters from "./togglefilters"

    export default {
        props: {
            canManageUsers: {
                type: Boolean,
                default: false
            },

            canDeleteCharts: {
                type: Boolean,
                default: false
            },

            canUpdateCharts: {
                type: Boolean,
                default: false
            },

            canCreateClients: {
                type: Boolean,
                default: false
            },

            canUpdateClients: {
                type: Boolean,
                default: false
            },
        },

        components: {
            ChartOrdering,
            ClientMenu,
            Logout,
            ToggleFilters,
        },

        mixins: [ClickOutsideMixin, ClientMenuMixin],

        data() {
            return {
                open: false,

                openFilters: false,

                openChartOrdering: false,

                showClientsMenu: false,
            }
        },

        computed: {
            charts: get('charts/charts'),
            client: get('auth/client'),
            clients: get('clients/clients'),
            user: get('auth/user'),

            hasCharts() {
                return this.charts.length > 0
            },

            isOpen() {
                return this.open
            },
        },

        watch: {
            openFilters(newValue, oldValue) {
                if (newValue !== oldValue && newValue) {
                    this.open = false
                }
            }
        },

        async mounted() {
            if (this.isLoggedIn && this.clients.length === 0) {
                await this.loadClients()
            }
        },

        methods: {
            clickOutsideHandler() {
                this.openChartOrdering = false
            },

            onOpen() {
                this.open = !this.open

                if (this.open) {
                    this.openFilters = false
                    this.openChartOrdering = false
                }
            },

            onOpenChartOrdering() {
                this.open = false
                this.openChartOrdering = true
            },
        },
    }

</script>